import type { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import {
  Box,
  Card,
  CardContent,
  Divider,
  Link,
  Typography
} from '@mui/material';
import RegisterJWT from '../../components/authentication/register/RegisterJWT'
import LayoutAuth from './LayoutAuth'

const Register: FC = () => {
  return (
    <LayoutAuth>
      <Helmet>
        <title>Register | OnData</title>
      </Helmet>
      <Card>
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            p: 4
          }}
        >
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'space-between',
              mb: 3
            }}
          >
            <div>
              <Typography
                color="textPrimary"
                gutterBottom
                variant="h4"
              >
                Register
              </Typography>
              <Typography
                color="textSecondary"
                variant="body2"
              >
                Create an OnData Account
              </Typography>
            </div>
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              mt: 3
            }}
          >
            <RegisterJWT />
          </Box>
          <Divider sx={{ my: 3 }} />
          <Typography
            color="textSecondary"
            variant="body2"
          >
            Already have an account?
            {' '}
            <Link
              color="primary"
              component={RouterLink}
              to="/login"
              underline="hover"
              variant="body2"
            >
              Sign in now.
            </Link>
          </Typography>
        </CardContent>
      </Card>
      
    </LayoutAuth>
  );
};

export default Register;
